export default __webpack_public_path__ + "static/suzuki_white-d43fc805580d9a1429cd30305dabae74.jpg";